import apiInvent from "../api/inventtypes";
import apiRoom from "../api/roomtypes";
import notify from "devextreme/ui/notify";

const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалсоь выполнить запрос"
    }
  ]
});

const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

  // RESOURCE TYPES
  const GET_RESOURCE_TYPES_REQUEST = "GET_RESOURCE_TYPES_REQUEST";
  const GET_RESOURCE_TYPES_COMPLETED = "GET_RESOURCE_TYPES_COMPLETED";
  const GET_RESOURCE_TYPES_ERROR = "GET_RESOURCE_TYPES_ERROR";

  const GET_RESOURCE_TYPE_REQUEST = "GET_RESOURCE_TYPE_REQUEST";
  const GET_RESOURCE_TYPE_COMPLETED = "GET_RESOURCE_TYPE_COMPLETED";
  const GET_RESOURCE_TYPE_ERROR = "GET_RESOURCE_TYPE_ERROR";

  // ROOM TYPES
  const GET_ROOM_TYPES_REQUEST = "GET_ROOM_TYPES_REQUEST";
  const GET_ROOM_TYPES_COMPLETED = "GET_ROOM_TYPES_COMPLETED";
  const GET_ROOM_TYPES_ERROR = "GET_ROOM_TYPES_ERROR";

  const GET_ROOM_TYPE_REQUEST = "GET_ROOM_TYPE_REQUEST";
  const GET_ROOM_TYPE_COMPLETED = "GET_ROOM_TYPE_COMPLETED";
  const GET_ROOM_TYPE_ERROR = "GET_ROOM_TYPE_ERROR";

  function requestResourceTypes() {
    return {
      type: GET_RESOURCE_TYPES_REQUEST,
      isFetchingResTypes: true
    };
  }

  function requestResourceTypesCompleted(restypes) {
    return {
      type: GET_RESOURCE_TYPES_COMPLETED,
      isFetchingResTypes: false,
      restypes
    };
  }

  function requestResourceTypesError(restypesError) {
    return {
      type: GET_RESOURCE_TYPES_ERROR,
      isFetchingResTypes: false,
      restypesError
    };
  }

  function requestRoomTypes() {
    return {
      type: GET_ROOM_TYPES_REQUEST,
      isFetchingRoomTypes: true
    };
  }

  function requestRoomTypesCompleted(roomtypes) {
    return {
      type: GET_ROOM_TYPES_COMPLETED,
      isFetchingRoomTypes: false,
      roomtypes
    };
  }

  function requestRoomTypesError(roomtypesError) {
    return {
      type: GET_ROOM_TYPES_ERROR,
      isFetchingRoomTypes: false,
      roomtypesError
    };
  }

  function requestResourceType() {
    return {
      type: GET_RESOURCE_TYPE_REQUEST,
      isFetchingResType: true
    };
  }

  function requestResourceTypeCompleted(restypeCard) {
    return {
      type: GET_RESOURCE_TYPE_COMPLETED,
      isFetchingResType: false,
      restypeCard
    };
  }

  function requestResourceTypeError(restypeCardError) {
    return {
      type: GET_RESOURCE_TYPE_ERROR,
      isFetchingResType: false,
      restypeCardError
    };
  }

  function requestRoomType() {
    return {
      type: GET_ROOM_TYPE_REQUEST,
      isFetchingRoomType: true
    };
  }

  function requestRoomTypeCompleted(roomtypeCard) {
    return {
      type: GET_ROOM_TYPE_COMPLETED,
      isFetchingRoomType: false,
      roomtypeCard
    };
  }

  function requestRoomTypeError(roomtypeCardError) {
    return {
      type: GET_ROOM_TYPE_ERROR,
      isFetchingRoomType: false,
      roomtypeCardError
    };
  }

  export function getResourceTypes() {
    return dispatch => {
      dispatch(requestResourceTypes());
      return apiInvent
        .getInventTypesList()
        .then(response => {
          if (response.status === 200) {
            dispatch(requestResourceTypesCompleted(response.data));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({message}) => message).join(", ");
            }
            logError(message);
            dispatch(requestResourceTypesError(message));
          } else {
            logError(err);
            dispatch(requestResourceTypesError(createError("Не удалось загрузить список")));
          }
        });
    };
  }

  export function getRoomTypes() {
    return dispatch => {
      dispatch(requestRoomTypes());
      return apiRoom
        .getRoomTypesList()
        .then(response => {
          if (response.status === 200) {
            dispatch(requestRoomTypesCompleted(response.data));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({message}) => message).join(", ");
            }
            logError(message);
            dispatch(requestRoomTypesError(message));
          } else {
            logError(err);
            dispatch(requestRoomTypesError(createError("Не удалось загрузить список")));
          }
        });
    };
  }

  export function getResourceType(id) {
    return dispatch => {
      dispatch(requestResourceType());
      return apiInvent
        .getInventType(id)
        .then(response => {
          if (response.status === 200) {
            let restype = response.data;
            restype = {
              info: restype.info,
              name: restype.data ? restype.data.name : "",
              code: restype.data ? restype.data.code : "",
              group: restype.data ? restype.data.group : 1,
              parentId: restype.data ? restype.data.parentId : null
            };
            dispatch(requestResourceTypeCompleted(restype));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({message}) => message).join(", ");
            }
            logError(message);
            dispatch(requestResourceTypeError(err.response));
          } else {
            logError(err);
            dispatch(requestResourceTypeError(createError("Не удалось получить данные")));
          }
        });
    };
  }

  export function getRoomType(id) {
    return dispatch => {
      dispatch(requestResourceType());
      return apiRoom
        .getRoomType(id)
        .then(response => {
          if (response.status === 200) {
            let roomtype = response.data;
            roomtype = {
              info: roomtype.info,
              name: roomtype.data ? roomtype.data.name : ""
            };
            dispatch(requestRoomTypeCompleted(roomtype));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({message}) => message).join(", ");
            }
            logError(message);
            dispatch(requestRoomTypeError(err.response));
          } else {
            logError(err);
            dispatch(requestRoomTypeError(createError("Не удалось получить данные")));
          }
        });
    };
  }

  export default {
    GET_RESOURCE_TYPES_REQUEST,
    GET_RESOURCE_TYPES_COMPLETED,
    GET_RESOURCE_TYPES_ERROR,
    GET_ROOM_TYPES_REQUEST,
    GET_ROOM_TYPES_COMPLETED,
    GET_ROOM_TYPES_ERROR,
    GET_RESOURCE_TYPE_REQUEST,
    GET_RESOURCE_TYPE_COMPLETED,
    GET_RESOURCE_TYPE_ERROR,
    GET_ROOM_TYPE_REQUEST,
    GET_ROOM_TYPE_COMPLETED,
    GET_ROOM_TYPE_ERROR,

    getResourceTypes,
    getRoomTypes,
    getResourceType,
    getRoomType
  };
